module.exports = __webpack_public_path__ + "static/micro-sitio-b6fdf2d37f93e684969294fc115001ae.png";